import React, { useState } from 'react';
import { Modal, Input, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setShowReloginModal, reloginUserClient, logOutUser } from '../../configurations/features/authSliceUser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const ReloginModal = () => {
    const dispatch = useDispatch();
    const { showReloginModal } = useSelector(state => state.authUser);
    const [loading, setLoading] = useState(false);
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = () => {
        if (login.trim().length >= 3 && password.trim().length >= 3) {
            setLoading(true);
            dispatch(reloginUserClient(login.trim(), password.trim(), setLoading));
        }
    };

    const handleCancel = () => {
        dispatch(setShowReloginModal(false));
        dispatch(logOutUser());
        window.location.href = '/login';
    };

    return (
        <Modal
            title="Session expirée ou refresh maximal atteint"
            open={showReloginModal}
            onCancel={handleCancel}
            footer={null}
            closable={false}
            maskClosable={false}
            centered
        >
            <div className="p-4">
                <p className="mb-6 text-gray-600">
                    Pour des raisons de sécurité, veuillez confirmer votre identité en entrant votre login et mot de passe à nouveau pour continuer sans perdre la page actuelle.
                </p>
                <div className="space-y-4">
                    <div>
                        <label className="mb-2 block text-sm font-medium text-gray-700">Nom d'utilisateur</label>
                        <Input
                            value={login}
                            onChange={(e) => setLogin(e.target.value)}
                            placeholder="Nom d'utilisateur"
                            size="large"
                        />
                    </div>
                    <div>
                        <label className="mb-2 block text-sm font-medium text-gray-700">Mot de passe</label>
                        <Input.Password
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Mot de passe"
                            size="large"
                            iconRender={(visible) => (visible ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />)}
                        />
                    </div>
                    <Button
                        type="primary"
                        size="large"
                        block
                        loading={loading}
                        onClick={handleSubmit}
                        disabled={login.trim().length < 3 || password.trim().length < 3}
                        className="bg-gradient-to-r from-blue-500 to-purple-500 border-none mt-4 hover:scale-105 transition-transform"
                    >
                        Se reconnecter
                    </Button>
                    <Button
                        type="default"
                        size="large"
                        block
                        onClick={handleCancel}
                        className="mt-2 text-red-500 border-red-500 hover:bg-red-50"
                    >
                        Annuler et se déconnecter
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ReloginModal;
